module.exports = __webpack_public_path__ + "img/additional_controls.339810ee.jpg";